// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__2xzF-","right":"styles_right__2LP8i"};